import { render, staticRenderFns } from "./CoreVideo.vue?vue&type=template&id=af6add40&"
import script from "./CoreVideo.vue?vue&type=script&lang=js&"
export * from "./CoreVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports